/* A short word that isn't a page: the password gate for a protected short link, and the 404. */
import { useEffect, useState } from "react";
import { APP } from "@/core";
import { openShort } from "@/data/supabase";
import { keepFeedback } from "@/data/feedback";

export interface ShortInfo { protected: boolean; honoreeName?: string; displayName?: string }

export function ShortLinkGate({ word, info }: { word: string; info: ShortInfo }) {
  const [pass, setPass] = useState(""); const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const name = (info && (info.displayName || info.honoreeName)) || "";
  useEffect(() => { document.title = name ? ("For " + name) : "KeepSakePage"; }, []);
  const go = async () => { if (!pass.trim() || busy) return; setBusy(true); setErr("");
    try { const r = await openShort(word, pass.trim()); location.replace(keepFeedback(APP.revealPath(r) as string, location.search)); }
    catch (e) { setErr(/wrong/i.test((e as Error).message || "") ? "That's not it — try again." : "Couldn't open this link right now."); setBusy(false); } };
  return (
    <div style={{ minHeight: "70vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px 22px" }}>
      <div style={{ fontSize: 50 }}>🎁</div>
      <h2 style={{ fontFamily: "'Fraunces',serif", margin: "10px 0 6px" }}>{name ? ("A keepsake for " + name) : "A keepsake page"}</h2>
      <p className="muted" style={{ maxWidth: 420 }}>This page is for family and friends. Enter the password you were given.</p>
      <div className="row" style={{ justifyContent: "center", marginTop: 10, gap: 8 }}>
        <input className="input" type="text" autoCapitalize="none" autoCorrect="off" style={{ maxWidth: 220, textAlign: "center" }} placeholder="Password" value={pass} autoFocus onChange={(e) => setPass(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") go(); }} />
        <button className="btn btn-primary" disabled={busy || !pass.trim()} onClick={go}>{busy ? "Opening…" : "Open"}</button>
      </div>
      {err && <div className="pill pill-bad" role="alert" style={{ marginTop: 12 }}>{err}</div>}
    </div>);
}

export function NotFoundPage() {
  useEffect(() => { document.title = "KeepSakePage"; }, []);
  return (
    <div style={{ minHeight: "70vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px 22px" }}>
      <div style={{ fontSize: 50 }}>🔎</div>
      <h2 style={{ fontFamily: "'Fraunces',serif", margin: "10px 0 6px" }}>No keepsake page here</h2>
      <p className="muted" style={{ maxWidth: 420 }}>Double-check the link with whoever shared it — it may have a small typo.</p>
      <a href="/" className="btn btn-ghost btn-sm" style={{ marginTop: 14 }}>← KeepSakePage home</a>
    </div>);
}

export function Splash() {
  return <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", gap: 14 }}><div className="spin" /><div className="muted">One moment…</div></div>;
}
